<template>
	<div v-if="templateStore.configs">
		<AppMenu @open="isMenuOpened = true" @close="isMenuOpened = false">
			<template #trigger>
				<AppButton
					startIcon="assets/v2/image/icons/plus.svg"
					:label="$t('templates.other.NewTemplate')"
					variant="brand"
					size="md"
				/>
			</template>
			<div class="menu-item" v-for="(option, i) in templateStore.configs?.types">
				<AppLink
					:to="{ name: 'create-new-template', params: { type: option.type } }"
					class="menu-link text-capitalize px-5"
					v-feature-flag="option.featureFlag ? { feature: option.featureFlag } : undefined"
				>
					{{ $t(`templates.Types.${option.type}`) }}
				</AppLink>
			</div>
		</AppMenu>
	</div>
</template>

<script setup>
import AppMenu from '@/v2/components/app-menu';
import AppLink from '@/v2//components/app-link.vue';
import { useTemplatesStore } from '@/v2/modules/whatsapp/stores/templates';
import { ref } from 'vue';

const templateStore = useTemplatesStore();
const isMenuOpened = ref(false);

function selectOption(type) {}
</script>

<style lang="scss" scoped></style>
